$('window').ready(function() {
      if( $('.site-announcement').length != 0){
        var annHeight = $('.site-announcement').height();
      } else{
        var annHeight = 0; 
      }
      let headerHeight = $('.site-header').outerHeight();
      $('.site-header').css("top", annHeight + "px");
      let innerHeight = window.innerHeight;
      $('.cart-drawer').css('height', innerHeight);
      if($('body').hasClass('index')) {
        $('main').css("padding-top", (annHeight + headerHeight) + "px");       
      } else {
        $('main').css("margin-top", (annHeight + headerHeight + 40) + "px");       
      }
});

addEventListener('load', (event) => {
      if( $('.site-announcement').length != 0){
        var annHeight = $('.site-announcement').height();
      } else{
        var annHeight = 0; 
      }
      let headerHeight = $('.site-header').outerHeight();
      $('.site-header').css("top", annHeight + "px");
      let innerHeight = window.innerHeight;
      // console.log(innerHeight);
      $('.cart-drawer').css('height', innerHeight);
      if($('body').hasClass('index')) {
        $('main').css("padding-top", (annHeight + headerHeight) + "px");       
      } else {
        // $('main').css("margin-top", (annHeight + headerHeight + 40) + "px");       
      }

});

addEventListener('scroll', (event) => {
      let innerHeight = window.innerHeight;
      $('.cart-drawer').css('height', innerHeight);
});

addEventListener('resize', (event) => {
     if( $('.site-announcement').length != 0){
        var annHeight = $('.site-announcement').height();
      } else{
        var annHeight = 0; 
      }
      let headerHeight = $('.site-header').outerHeight();
      $('.site-header').css("top", annHeight + "px");
      // $('main').css("padding-top", (annHeight + headerHeight) + "px");
    
      let innerHeight = window.innerHeight;
      $('.cart-drawer').css('height', innerHeight);
});

$('.site-announcement .icon-close').click(function() {
      let headerHeight = $('.site-header').outerHeight();
      $('.site-announcement').css("display", "none");
      $('.site-header').css("top", "0px");
      if($('body').hasClass('index')) {
        $('main').css("padding-top", headerHeight + "px");       
      } else {
        // $('main').css("margin-top", (headerHeight + 40) + "px");       
      }
});

// Reinitialize yotpo widget for product recommendation
$(window).on('load', function() {
   if($('.shopify-section--recommended-products').length){
    var api = new Yotpo.API(yotpo);
    api.refreshWidgets();
  }
});
$(function() {
   // mobile add to cart
    if ($('.addToCart').length != 0) {
     
        $(document).on("click",".addToCart .addToCart__btn",function(e) { 
            e.preventDefault();
            $(".addToCart__list").removeClass("addToCart__list--open");
            $(this).parent().find(".addToCart__list").toggleClass("addToCart__list--open");
        });
    }
});
